import { useContext } from 'react';
import { DeviceTypesContext, DeviceTypesContextType } from '../device-types.context';

export const useDeviceTypesContext = (): DeviceTypesContextType => {
    const context = useContext(DeviceTypesContext);
    if (context === undefined) {
        throw new Error('useDeviceTypesContext must be used within DeviceTypesProvider');
    }
    return context;
};
